// library
import React from 'react';
// internal
// components

export default function ScreenshareIcon({
  width,
  height,
  fill,
  additionalStyles,
  isSharing,
}) {
  const style = {
    width: `${width}px`,
    height: `${height}px`,
    ...additionalStyles,
  };
  const viewBox = `0 0 ${32} ${34}`;
  const line = isSharing ? (
    <line
      x1="30.7408"
      y1="0"
      x2="0"
      y2="24.2592"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
    />
  ) : null;
  return (
    <svg style={style} viewBox={viewBox} className="hand-icon">
      <path
        d="M27.0267 21.9997H15.9156C15.4091 21.9997 14.9989 21.5895 14.9989 21.083C14.9989 20.5766 15.4091 20.1664 15.9156 20.1664H27.0267C27.2834 20.1664 27.4999 19.9498 27.4999 19.6931V2.29508C27.4999 2.04529 27.2891 1.83332 27.0382 1.83332H2.29508C2.04071 1.83332 1.83332 2.04071 1.83332 2.29508V5.9582C1.83332 6.46467 1.42313 6.87486 0.91666 6.87486C0.410194 6.87486 0 6.46467 0 5.9582V2.29508C0 1.02895 1.02895 0 2.29508 0H27.0382C28.3043 0 29.3332 1.02895 29.3332 2.29508V19.6931C29.3332 20.965 28.2986 21.9997 27.0267 21.9997Z"
        fill={fill}
      />
      <path
        d="M1.83335 21.083C1.83335 22.3056 3.05176e-05 22.3056 3.05176e-05 21.083C3.05176e-05 19.8604 1.83335 19.8604 1.83335 21.083Z"
        fill={fill}
      />
      <path
        d="M4.58333 21.9997C4.07687 21.9997 3.66667 21.5895 3.66667 21.0831C3.66667 19.5671 2.43263 18.3331 0.916691 18.3331C0.410225 18.3331 3.05176e-05 17.9229 3.05176e-05 17.4164C3.05176e-05 16.91 0.410225 16.4998 0.916691 16.4998C3.44438 16.4998 5.49999 18.5554 5.49999 21.0831C5.49999 21.5895 5.0898 21.9997 4.58333 21.9997Z"
        fill={fill}
      />
      <path
        d="M8.24997 21.9996C7.74351 21.9996 7.33331 21.5894 7.33331 21.0829C7.33331 17.5457 4.455 14.6663 0.916691 14.6663C0.410225 14.6663 3.05176e-05 14.2561 3.05176e-05 13.7497C3.05176e-05 13.2432 0.410225 12.833 0.916691 12.833C5.46567 12.833 9.16663 16.534 9.16663 21.0829C9.16663 21.5894 8.75644 21.9996 8.24997 21.9996Z"
        fill={fill}
      />
      <path
        d="M11.9166 21.9997C11.4101 21.9997 11 21.5896 11 21.0831C11 15.5236 6.4762 10.9998 0.916691 10.9998C0.410225 10.9998 3.05176e-05 10.5896 3.05176e-05 10.0832C3.05176e-05 9.5767 0.410225 9.1665 0.916691 9.1665C7.48672 9.1665 12.8333 14.5131 12.8333 21.0831C12.8333 21.5896 12.4231 21.9997 11.9166 21.9997Z"
        fill={fill}
      />
      {line}
    </svg>
  );
}
